import apiClient from './client'

import type { DiuresisEntry, DiuresisEntryInput, DiuresisSummaryItem, PaginatedResponse, PanalValue } from '@/types/gia'

interface DiuresisFilters {
  page?: number
  centro?: number
  atendido?: number
  fecha?: string
  q?: string
  fecha_from?: string
  fecha_to?: string
  atendidos?: number[]
}

const diuresisApi = {
  list: async (filters: DiuresisFilters = {}): Promise<PaginatedResponse<DiuresisEntry>> => {
    const params: Record<string, any> = { ...filters }
    if (filters.atendidos?.length) {
      params.atendidos = filters.atendidos.join(',')
    }
    const response = await apiClient.get<PaginatedResponse<DiuresisEntry>>('/diuresis/', {
      params
    })

    return response.data
  },

  summary: async (filters: DiuresisFilters = {}): Promise<PaginatedResponse<DiuresisSummaryItem>> => {
    const response = await apiClient.get<PaginatedResponse<DiuresisSummaryItem>>('/diuresis/summary/', {
      params: filters
    })

    return response.data
  },

  create: async (data: DiuresisEntryInput): Promise<DiuresisEntry> => {
    const response = await apiClient.post<DiuresisEntry>('/diuresis/', data)

    return response.data
  },

  update: async (id: number, data: Partial<DiuresisEntryInput>): Promise<DiuresisEntry> => {
    const response = await apiClient.patch<DiuresisEntry>(`/diuresis/${id}/`, data)

    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/diuresis/${id}/`)
  },

  bulk: async (payload: {
    centro: number
    fecha: string
    hora: string
    entries: Array<{
      atendido: number
      usuario_en_wc?: boolean
      miccion?: boolean
      panal?: PanalValue
      observaciones?: string
    }>
  }): Promise<DiuresisEntry[]> => {
    const response = await apiClient.post<DiuresisEntry[]>('/diuresis/bulk/', payload)

    return response.data
  }
}

export default diuresisApi
